import React, {useMemo} from 'react';
import PriceFilter from '@new-components/molecules/PriceFilter';
import {FilterPopup} from '@new-components/molecules/FilterPopup';

export type SelectionType = {
  min: number | string | null;
  max: number | string | null;
};

export type SearchPriceFilterProps = {
  step?: number;
  min?: number;
  max?: number;
  currency?: string;
  value: SelectionType;
  handleChange: (arg: SelectionType) => void;
};

const SearchPriceFilter = (props: SearchPriceFilterProps) => {
  const filterValue = useMemo(() => {
    if (!props.value?.min && !props.value.max) {
      return 'Choose';
    } else if (props.value.min && !props.value.max) {
      return `${props.value.min} - Any`;
    } else if (props.value.max && !props.value?.min) {
      return `Any - ${props.value.max}`;
    }

    return `${props.value.min} - ${props.value.max}`;
  }, [props.value]);

  return (
    <FilterPopup label='Price' value={filterValue}>
      <PriceFilter
        max={props.max}
        min={props.min}
        step={props.step}
        currency={props.currency}
        hasReset={true}
        label='Price Range'
        value={props.value}
        handleChange={props.handleChange}
      />
    </FilterPopup>
  );
};

export default SearchPriceFilter;
